// Utils
import { openColorEyeDropper, isEyeDropperSupported } from '../../utils/color/eyedropperUtil';
import { updateDrawingToolStrokeColor } from '../../element/drawing/utils/drawingColorUtils';

// Selectors
import { getSelectedElements } from '../../element/selection/selectedElementsSelector';
import { getIsAnnotationModeEnabled } from '../../element/drawing/annotation/store/annotationSelector';
import { isSketchModalOpen } from '../../element/drawing/sketch/modal/sketchModalSelector';

// Types
import { GenericReduxThunkAction } from '../../../common/actions/actionTypes';

// Utils
import globalLogger from '../../logger';

const logger = globalLogger.createChannel('workspace.eyedropper');

/**
 * Handles eyeDropper keyboard action for annotation mode or sketch modal.
 */
export const handleEyeDropperKeyboardAction = (): GenericReduxThunkAction => {
    return async (dispatch, getState) => {
        if (!isEyeDropperSupported()) {
            logger.warn('EyeDropper API is not supported in this browser');
            return;
        }

        const state = getState();

        // Only handle annotation mode - color tools handle themselves
        const isInAnnotationMode = getIsAnnotationModeEnabled(state);
        const selectedElements = getSelectedElements(state);
        const hasSingleSelectedElement = selectedElements.size === 1;

        if (!isInAnnotationMode && !(hasSingleSelectedElement && isSketchModalOpen(state))) {
            logger.warn('Eye dropper is only available in annotation mode when called globally');
            return;
        }

        try {
            // Open the eyeDropper only if we have a valid context
            const color = await openColorEyeDropper();
            if (!color) {
                return;
            }

            // Apply to annotation mode or sketch modal
            if (isInAnnotationMode || (hasSingleSelectedElement && isSketchModalOpen(state))) {
                updateDrawingToolStrokeColor(color);
                return;
            }
        } catch (error) {
            logger.error('Failed to use eyeDropper', error);
        }
    };
};
